import React, { Component } from 'react'
import Slider from 'react-slick'
import Img from 'gatsby-image'

import Icon from '@/icons'
import Popup from '@/popup'
import MainSectionLayout from '@/main-section-layout'
import GetStartedButton from '@/get-started-button'

import './styles.css'

class SectionMain extends Component {
  state = {
    videoActive: false
  }

  onVideoShow = () => {
    this.setState({ videoActive: true })
  }

  onVideoClose = () => {
    this.setState({ videoActive: false })
  }

  render() {
    const { data } = this.props
    const { videoActive } = this.state

    const settings = {
      dots: true,
      slidesToShow: 1,
      arrows: false,
      fade: true,
      autoplay: true,
      autoplaySpeed: 5000
    }

    return (
      <MainSectionLayout
        noLogo
        title="Next level digital tools for your beauty pageant"
        about="Bring your casting, voting and judge rating to the digital age today!"
      >
        <div className="mb4">
          <Slider {...settings}>
            <Img sizes={data.landerSlide0.sizes} alt="" />
            <Img sizes={data.landerSlide1.sizes} alt="" />
            <Img sizes={data.landerSlide2.sizes} alt="" />
            <Img sizes={data.landerSlide3.sizes} alt="" />
            <Img sizes={data.landerSlide4.sizes} alt="" />
          </Slider>
        </div>

        <div className="tr ph3 mb4">
          <button
            className="ttu f12 ba b--black br-pill pv2 ph3 dim pointer bg-transparent"
            onClick={this.onVideoShow}
          >
            <div className="flex items-center lh-copy">
              <Icon icon="play" size="13px" className="mr2" />
              Play intro video
            </div>
          </button>
        </div>

        <GetStartedButton />

        {videoActive && (
          <Popup onClose={this.onVideoClose} width="876px">
            <div className="aspect-ratio aspect-ratio--16x9 bg-loader">
              <iframe
                title="choicely for beauty"
                src="https://player.vimeo.com/video/291392803?autoplay=1&color=27c081"
                className="aspect-ratio--object bw0 db"
                frameBorder="0"
                allowFullScreen
              />
            </div>
          </Popup>
        )}
      </MainSectionLayout>
    )
  }
}

export default SectionMain



// WEBPACK FOOTER //
// ./src/components/section-main/section-main.js